import { render, staticRenderFns } from "./MathCaptcha.vue?vue&type=template&id=36acfe9c&scoped=true"
import script from "./MathCaptcha.vue?vue&type=script&lang=js"
export * from "./MathCaptcha.vue?vue&type=script&lang=js"
import style0 from "./MathCaptcha.vue?vue&type=style&index=0&id=36acfe9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acfe9c",
  null
  
)

export default component.exports